<template>
  <div class="footer">
    <div class="sb-footer-hd">
      <div class="qrcode">
        <img :src="basicConfig.qr_code" alt />
        <p>{{ basicConfig.qr_code_clues }}</p>
      </div>
      <div class="item center">
        <div>
          <!--<router-link to="enter" tag="span">商家入驻</router-link>
          <span>|</span>-->
          <router-link to="amap" tag="span">联系方式</router-link>
          <span>|</span>
          <router-link to="talnet" tag="span">人才招聘</router-link>
          <span>|</span>
          <router-link to="about" tag="span">关于我们</router-link>
        </div>
        <p>{{ basicConfig.detail_address }}</p>
      </div>
      <div class="item right">
        <div>
          <span>座机：{{ basicConfig.tel }}</span>
          <span>电话：{{ basicConfig.mob }}</span>
          <span>EMAIL：{{ basicConfig.email }}</span>
        </div>
        <div class="btn-div">
          <div>
            <!-- ©️版权所有： -->
            <!-- <span>{{ basicConfig.copyright }}</span> -->
            <!-- ICP证： -->
            <!-- <span>{{ basicConfig.icp }}</span> -->
          </div>
          <!--<el-button class="btn" v-if="!isLogin">
            <router-link to="/staff/login" tag="span">登录</router-link>
          </el-button>
          <el-button class="btn" v-else>安全退出</el-button>-->
        </div>
      </div>
    </div>
    <div class="sb-footer-bd">
      <span>增值电信业务经营许可证：浙B2-20180116</span>
      <b>|</b>
      <span>出版物经营许可证备案号：新出发浙杭江零字00003号</span>
      <b>|</b>
      <span>广播电视节目录制经营许可证（浙）字05166号</span>
      <b>|</b>
      <span>互联网药品信息服务资格证书（新）-非经营性-2019-0021</span>
      <b>|</b>
      <span>食品经营许可证：JY1330104006371</span>
      <b>|</b>
      <span>浙杭药食监械经营备案：20200096号</span>
      <b>|</b>
      <span>浙杭药食监械经营备案：20204945号</span>
      <b>|</b>
      <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33010402003150" target="_blank" rel="noopener noreferrer">
        <img src="../assets/footer/beian.png" alt="" style="width: 20px; height: 20px;margin-bottom: 8px;" />
        <span>
        浙公网安备:33010402003150号
        </span>
      </a>
      <b>|</b>
      <span style="white-space: nowrap;display: flex;align-items: center;height: 16px;">&copy;2013-现在 shall-buy.com 版权所有 <a href="https://beian.miit.gov.cn" target="_blank">浙ICP备16036486号-1</a></span>
    </div>
    <div class="sb-footer-ft">
      <a target="cyxyv" href="https://v.yunaq.com/certificate?domain=www.shall-buy.com&from=label&code=90030"> 
            <img src="https://aqyzmedia.yunaq.com/labels/label_sm_90030.png">
          </a>

          <a href="https://kx.xcc.cn/newCan/2022050729031112246" target="_blank" style="position: relative;">
            <div style="width:100%;height:100%;position: absolute;top: 0;left: 0;"></div>
            <embed src="https://program.xinchacha.com/cre/2022050729031112246.svg" width="103" height="38" type="image/svg+xml" pluginspage="//www.adobe.com/svg/viewer/install/"/>
          </a>

          <a id="_xinchacharenzheng_cert_vip_kexinweb" style="text-decoration:none;" target="_blank" href="https://xyt.xinchacha.com/pcinfo?sn=1522865145112711168&certType=6">
            <img src="https://program.xinchacha.com/xyt/icon3.png" style="height:38px;width:117px;">
          </a>
          <a href="https://xyt.xinchacha.com/pcinfo?sn=1529365795165237248&certType=3" target="_blank" style="position: relative;">
            <div style="width:100%;height:100%;position: absolute;top: 0;left: 0;"></div>
            <embed src="https://program.xinchacha.com/industry/XCCXYTPP20220525QPXY.svg" style="height:38px;width:117px;" type="image/svg+xml" pluginspage="//www.adobe.com/svg/viewer/install/"/>
          </a>



        <a
          id="_xinchacharenzheng_cert_vip_ssl"
          style="text-decoration:none;"
          target="_blank"
          href="https://xyt.xinchacha.com/getpcInfo?sn=1511998907142246400&certType=8&url=*.shall-buy.com"
        >
          <img src="https://xyt.xinchacha.com/img/icon/icon8.png" />
        </a>

        <a href="https://www.12377.cn/" rel="noopener noreferrer" target="_blank">
          <img src="https://img.alicdn.com/tfs/TB1N7kwRVXXXXbAapXXXXXXXXXX-500-127.png_250x250" alt="" />
        </a>

        <a href="http://www.12377.cn/node_548446.htm?spm=a21bo.jianhua/evo255811b326291.1997523009.45.5af911d9AplXeH" rel="noopener noreferrer" target="_blank" class="tb-footer-mod" data-spm-anchor-id="a21bo.jianhua/evo255811b326291.1997523009.45" style="width: 105px; height: 38px; display: inline-block; background-position: -650px 0px; background-image: url('https://img.alicdn.com/tfs/TB1EPnIQXXXXXaSXpXXXXXXXXXX-1133-35.jpg');"></a>

        <!-- <a href="https://credit.szfw.org/CX20160715023573390688.html?spm=a21bo.jianhua/evo255811b326291.1997523009.46.5af911d9AplXeH" rel="noopener noreferrer" target="_blank" class="tb-footer-mod" data-spm-anchor-id="a21bo.jianhua/evo255811b326291.1997523009.46" style="width: 97px; height: 38px; display: inline-block; background-position: -761px 0px; background-image: url('https://img.alicdn.com/tfs/TB1EPnIQXXXXXaSXpXXXXXXXXXX-1133-35.jpg');"></a> -->

        <a href="https://jbts.mct.gov.cn/?spm=a21bo.jianhua/evo255811b326291.1997523009.47.5af911d9AplXeH" rel="noopener noreferrer" target="_blank" class="tb-footer-mod" data-spm-anchor-id="a21bo.jianhua/evo255811b326291.1997523009.47" style="width: 249px;height: 38px; display: inline-block; background-position: -884px 0px; background-image: url('https://img.alicdn.com/tfs/TB1EPnIQXXXXXaSXpXXXXXXXXXX-1133-35.jpg');"></a>

        <a href="http://www.shdf.gov.cn/shdf/channels/740.html?spm=a21bo.jianhua/evo255811b326291.1997523009.48.5af911d9AplXeH" rel="noopener noreferrer" target="_blank">
          <img src="https://img.alicdn.com/tfs/TB1SKn6MAY2gK0jSZFgXXc5OFXa-249-40.jpg" alt="" />
        </a>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isLogin: false,
      basicConfig: {},
    };
  },
  created() {
    this.initBasicConfig();
  },
  methods: {
    initBasicConfig() {
      let config = this.$cache.get("basicConfig");
      this.basicConfig = config || {};
    },
  },
};
</script>
<style lang="less" scoped>
.footer {
  width: 1200px;
  margin: 0 auto;
  background: #232529;
  padding:  40px 0;
  display: flex;
  flex-direction: column;
  align-items: center;

  .sb-footer-hd {
    display: flex;
    margin-bottom: 16px;
  }

  .qrcode {
    width: 208px;
    font-size: 0;
    padding: 0 38px 0 61px;

    img {
      width: 109px;
      height: 109px;
    }
    p {
      font-size: 13px;
      color: #fff;
      margin-top: 15px;
      text-align: center;
    }
  }
  .item {
    border-left: 1px solid rgba(255, 255, 255, 0.2);
    height: 137px;
    padding: 0 30px;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    color: rgba(255, 255, 255, 0.5);
    font-size: 15px;

    &.center {
      span {
        &:nth-child(even) {
          padding: 0 10px;
        }
        &:nth-child(odd) {
          cursor: pointer;

          &:hover {
            color: #fff;
          }
        }
      }
    }
    &.right {
      flex: 1;

      span {
        margin-right: 16px;
        white-space: nowrap;

        &:last-of-type {
          margin: 0;
        }
      }
      .btn {
        background-color: #fff;
        color: #232529;
        padding: 5px 8px;
      }
      & > div,
      .btn-div {
        display: flex;
        justify-content: space-between;
        a {
          width: 131.2px;
          height: 40px;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }
}

.sb-footer-bd {
  padding: 0 32px;
  color: #9e9e9e;
  display: flex;
  flex-wrap: wrap;
  font-size: 12px;
  margin-bottom: 16px;
  span {
    padding: 0 8px;
    // display: inline-block;
    margin-bottom: 8px;
    // display: flex;
    // align-items: center;
  }
  b {
    color: #ddd;
    font-weight: 400;
  }
  a {
    color: #6c6c6c;
    padding: 0 8px;
    display: flex;
    align-items: center;
    text-decoration: none;
    > span {
      padding-left: 4px;
    }
    &:hover {
      color: #fe8735;
    }
  }
}

.sb-footer-ft {
  padding: 0 40px;
  & > a {
    margin-right: 15px;
  }
  img {
    height: 38px;
  }
}
</style>
